import { Box, Stack, Typography } from '@mui/material'
import { Certificate } from 'api/certificates'
import { downloadMediaFile, getMediaFileUrl } from 'api/mediaFiles'
import { UICertificateIcon, UIDownloadIcon } from 'features/UI'
import moment from 'moment'

export const CertificateItem = ({ certificate }: { certificate: Certificate }) => {
  return (
    <Stack
      display="flex"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      p={1}
      borderRadius={2}
      sx={{ background: 'white' }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box p={1} display="flex" justifyContent="center" alignItems="center">
          <UICertificateIcon />
        </Box>
        <Stack direction="column" alignItems="flex-start" spacing={0.25}>
          <Typography variant="body1" fontWeight="bold">
            {certificate.name}
          </Typography>

          <div>Passed {moment(certificate.createdAt).format('DD/MM/YY')}</div>
        </Stack>
      </Stack>
      <Box
        p={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
      >
        <UIDownloadIcon
          onClick={async () => {
            await downloadMediaFile(Number(certificate.pdfFile?.mediaFileId))
          }}
        />
      </Box>
    </Stack>
  )
}
